import React from 'react'

import cn from 'classnames'
import cl from './Gallery.scss'
import uiEventEmitter, { UIEvents } from 'Utils/uiEventEmitter'
import ScrollableList from 'Components/ScrollableList/ScrollableList'
import { ImageModal } from 'Components/Imagemodal';


type PropType = {
  store: Webshop.IStoreData
}

type StateType = {
  selectedImageId: number | null
}

export const openImageModal = (imageUrls: string[], selectedId: number) => {
  const modalStyles: React.CSSProperties = {
    border: 0,
    borderRadius: 0,
    padding: 0,
    backgroundColor: 'rgba(255, 255, 255, 0)',
    boxShadow: 'none',
    overflow: 'visible'
  }
  uiEventEmitter.emit(UIEvents.SHOW_MODAL, <ImageModal defaultSelected={selectedId} imageUrls={imageUrls} />, () => {}, { style: modalStyles })
}

class StoreGallery extends React.Component<PropType, StateType> {
  public state: StateType = {
    selectedImageId: null
  }

  open (id: number) {
    const urls = this.props.store.gallery.map(entry => entry.main)
    openImageModal(urls, id)
  }

  render () {
    const { store } = this.props

    return (
      <ScrollableList
        listItemNoBorders
        listItemsContent={
          store.gallery.map((image, id) => 
            <div key={image.main} className={cn(cl.thmb, { [cl.active]: id === this.state.selectedImageId })} onClick={() => this.open(id)} >
              <span></span>
              <img src={image.thumbnail} />
            </div>
        )}
      />
    )
  }
}

export default StoreGallery